import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import PersonIcon from '@material-ui/icons/PersonOutline';
import MenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import TypographyStyles from '../../styles/typography';
import combineStyles from './../../utils/combineStyles';
import ContactItemStyles from './__styles__/ContactItem.styles';

export class ContactItem extends PureComponent {
  static propTypes = {
    contact: PropTypes.object.isRequired,
    primaryContactId: PropTypes.number,
    onSetPrimaryContact: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onRemoveContactClick: PropTypes.func.isRequired,
    locationContactLinkId: PropTypes.number
  };
  state = {
    menuElement: null
  };

  _handleMenuClick = event => {
    this.setState({ menuElement: event.currentTarget });
  };
  _handleMenuClose = () => {
    this.setState({ menuElement: null });
  };
  render() {
    const {
      contact,
      classes,
      t,
      primaryContactId,
      onSetPrimaryContact,
      onEditClick,
      onRemoveContactClick,
      locationContactLinkId
    } = this.props;
    const { menuElement } = this.state;
    const isPrimaryContact = primaryContactId === parseInt(contact.id);
    return (
      <div className={classes.rowContainer}>
        <div>
          <PersonIcon
            classes={{
              root: classes.iconRoot
            }}
          />
        </div>
        <div className={classes.contactInfoContainer}>
          <p className={classes.subtitle3}>
            {contact.firstName} {contact.lastName}
          </p>
          <p className={classes.body2}>{contact.phone}</p>
          <p className={classes.body2}>{contact.email}</p>
        </div>
        <div className={classes.primaryContactContainer}>
          {isPrimaryContact && (
            <div
              className={classnames(
                classes.primaryContact,
                classes.caption,
                classes.mediumWeight
              )}
            >
              <span>{t('Primary Contact')}</span>
            </div>
          )}
        </div>
        <div>
          <IconButton
            color="primary"
            disableRipple={true}
            onClick={this._handleMenuClick}
            classes={{
              root: classnames(
                classes.noPadding,
                classes.menuButton,
                classes.statusMenu
              )
            }}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <Menu
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this._handleMenuClose}
        >
          {!isPrimaryContact && (
            <MenuItem
              onClick={() => {
                onSetPrimaryContact(contact.id);
                this._handleMenuClose();
              }}
            >
              {t('Mark as Primary')}
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              onEditClick(contact);
              this._handleMenuClose();
            }}
          >
            {t('Edit')}
          </MenuItem>
          <MenuItem
            onClick={() => {
              onRemoveContactClick(locationContactLinkId);
              this._handleMenuClose();
            }}
          >
            {t('Remove')}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}
const translatedContactItem = withNamespaces()(ContactItem);

export default withStyles(combineStyles(ContactItemStyles, TypographyStyles))(
  translatedContactItem
);
